import React, { useState, useEffect } from "react";
import SelectLayout from "./SelectLayout";
import AddWidget from "./AddWidget";
import ScrollView from "../common/ScrollView";
import _ from "lodash";

import RailGrid from "../common/railGrid/RailGrid";
import MOC from "../common/managementOfChange/ManagementOfChange";
import Gemba from "../common/gembaTracking/GembaTracking";
import HSECommunications from "../common/hseCommunication/HSECommunications";
import TableauRender from "../common/tableauRender/TableauRender";
import DowntimeReason from "../common/downtimeReason/DowntimeReason";
import Communications from "../common/communications/Communications";
import NexusCalendar from "../common/nexusCalendar/NexusCalendar";
import Incident from "../common/incidents/Incident";
import RPS from "../common/rps/RPS";

export default ({
  addLayout,
  rowData,
  template,
  deleteRow,
  onWidgetSelect,
  tier,
  site,
  tableuaData,
  reorderRows,
  reorderCols,
  activeItem,
  setWidgetVisibility,
  deleteWidget,
  reorderWidget,
  subTiers,
  isBaseLayout,
}) => {
  const [rowInfo, setRowInfo] = useState(rowData);
  const [showLayout, setShowLayout] = useState(false);
  const [showAddWidget, setShowAddWidget] = useState(false);
  const [activeGrid, setActiveGrid] = useState([]);
  const [editWidgetInfo, setEditWidgetInfo] = useState(null);

  const defaultMenu = [
    "performance",
    "safety",
    "quality",
    "delivery",
    "inventory",
    "cost",
    "people",
  ];
  let activeMenu = template && !template[activeItem] ? 0 : activeItem;
  // Changes related to 776 Comment - Right panel throws error while no menu items available is taken care below
  let isCustomMenu =
    template && template[activeMenu] && template[activeMenu]["id"]
      ? defaultMenu.indexOf(template[activeMenu]["id"]) == -1
      : true;

  const onLayoutSelect = (layout) => {
    setShowLayout(false);
    addLayout(layout);
  };

  const onAddWidgetClick = (i, j) => {
    setActiveGrid([i, j]);
    setEditWidgetInfo(null);
    setShowAddWidget(true);
  };

  const onWidgetSelected = (widget, title, htmlData, widgetId, filter) => {
    onWidgetSelect(widget, activeGrid, title, htmlData, widgetId, filter);
  };

  const editWidget = (i, j, k) => {
    let data = rowInfo;
    let widgetInfo;
    if (k !== undefined) widgetInfo = data[i].rowItems[j][k];
    else widgetInfo = data[i].rowItems[j];
    setActiveGrid([i, j, k]);
    setShowAddWidget(true);
    setEditWidgetInfo(widgetInfo);
  };

  const getWidget = (data) => {
    let { performance, safety, quality, delivery, cost, inventory, people } =
      tableuaData;

    let widget;
    switch (data.itemId) {
      case "perfTableua":
        widget = performance ? <TableauRender data={performance} /> : "";
        break;

      case "safetyCross":
        widget = safety ? <TableauRender data={safety} /> : "";
        break;

      case "qualityTableua":
        widget = quality ? <TableauRender data={quality} /> : "";
        break;

      case "inventoryTableua":
        widget = inventory ? <TableauRender data={inventory} /> : "";
        break;

      case "costTableua":
        widget = cost ? <TableauRender data={cost} /> : "";
        break;

      case "peopleTableua":
        widget = people ? <TableauRender data={people} /> : "";
        break;

      case "deliveryTableua":
        widget = delivery ? <TableauRender data={delivery} /> : "";
        break;

      /* case 'gembaTracking':
                 widget = <Gemba tierId={tier} siteId={site}/>
                 break;
 
                */

      case "mocWidget":
        widget = <MOC tierId={tier} siteId={site} />;
        break;

      case "managementofchange":
        widget = "";
        break;
      case "gembaTracking":
        return (
          <div className="col" key={data.itemId}>
            <div className="col-heading">{data.title}</div>
            <div className="col-body">
              <Gemba tierId={tier} siteId={site} />
            </div>
            <div></div>
            {/* <div className="col-heading">{"Incident"}</div>
            <div className="col-body">
              <Incident tierId={tier} siteId={site} />
            </div> */}
            <div className="col-heading">{"Management of Change"}</div>
            <div className="col-body">
              <MOC tierId={tier} siteId={site} />
            </div>
          </div>
        );
      case "hseCommunication":
        widget = <HSECommunications tierId={tier} siteId={site} />;
        break;

      case "rpsWidget":
        widget = <RPS tierId={tier} siteId={site} />;
        break;

      case "perfRailGrid":
        widget = <RailGrid tab="" tierId={tier} siteId={site} />;
        break;

      case "railGrid":
        widget = <RailGrid tab="Safety" tierId={tier} siteId={site} />;
        break;

      case "qualityRail":
        widget = <RailGrid tab="Quality" tierId={tier} siteId={site} />;
        break;

      case "deliveryRail":
        widget = <RailGrid tab="Delivery" tierId={tier} siteId={site} />;
        break;

      case "inventoryRail":
        widget = <RailGrid tab="Inventory" tierId={tier} siteId={site} />;
        break;

      case "costRail":
        widget = <RailGrid tab="Cost" tierId={tier} siteId={site} />;
        break;

      case "peopleRail":
        widget = <RailGrid tab="People" tierId={tier} siteId={site} />;
        break;

      case "downtimeReason":
        widget = <DowntimeReason tierId={tier} siteId={site} />;
        break;
      case "communication":
        widget = <Communications tierId={tier} siteId={site} data={rowInfo} />;
        break;
      case "calendar":
        widget = <NexusCalendar tierId={tier} siteId={site} />;
        break;
      //Custom items
      case "rail":
        widget = <RailGrid tab="" tierId={tier} siteId={site} />;
        break;
      case "html":
        widget = renderHtmlContent(data.description);
        break;
      case "tableau":
        widget = <TableauRender data={data.description} />;
        break;

      default:
        widget = <div></div>;
        break;
    }

    return widget ? (
      <div className="" key={data.itemId}>
        <div className="col-heading">{data.title}</div>
        <div className="col-body">{widget}</div>
      </div>
    ) : (
      ""
    );
  };

  const renderHtmlContent = (data) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `${data}`,
        }}
      ></div>
    );
  };

  useEffect(() => {
    setRowInfo(rowData);
    setShowLayout(false);
    setShowAddWidget(false);
  }, [rowData]);

  return (
    <ScrollView>
      <div className="content-body">
        {rowInfo &&
          rowInfo.map((item, i) => (
            <div className="rows" key={i}>
              {isCustomMenu && (
                <div className="row-edit-icons">
                  {i > 0 && (
                    <i
                      title="Move up row"
                      onClick={() => reorderRows(i, true)}
                      className="fas fa-arrow-up row-move-up-adj"
                    ></i>
                  )}
                  {i < rowInfo.length - 1 && (
                    <i
                      title="Move down row"
                      onClick={() => reorderRows(i, false)}
                      className="fas fa-arrow-down row-move-down-adj"
                    ></i>
                  )}
                </div>
              )}
              {isCustomMenu && (
                <span
                  onClick={() => deleteRow(i)}
                  className="icon remove-icon remove-row"
                ></span>
              )}
              {item.rowItems.map((col, j) => {
                if (!_.isArray(col)) {
                  return (
                    <div className="col" key={j}>
                      {isCustomMenu && (
                        <div className="col-edit-icons">
                          {j > 0 && (
                            <i
                              title="Move left"
                              onClick={() => reorderCols(i, j, true)}
                              className="fas fa-arrow-left row-move-up-adj"
                            ></i>
                          )}
                          {j < item.rowItems.length - 1 && (
                            <i
                              title="Move right"
                              onClick={() => reorderCols(i, j, false)}
                              className="fas fa-arrow-right row-move-down-adj"
                            ></i>
                          )}
                        </div>
                      )}

                      {col.itemId ? (
                        <>
                          {isCustomMenu && (
                            <i
                              onClick={() => editWidget(i, j)}
                              className="fas fa-edit row-move-edit-adj"
                            ></i>
                          )}
                          {col.isActive ? (
                            <i
                              title="Active"
                              onClick={() => setWidgetVisibility([i, j])}
                              style={{
                                right: "30px",
                                top: "8px",
                                position: "absolute",
                              }}
                              className="fas fa-eye"
                            ></i>
                          ) : (
                            <i
                              onClick={() => setWidgetVisibility([i, j])}
                              style={{
                                right: "30px",
                                top: "8px",
                                position: "absolute",
                              }}
                              className="fas fa-eye-slash"
                              title="Inactive"
                            ></i>
                          )}
                          {col.title}
                          <button
                            onClick={() => onAddWidgetClick(i, j)}
                            className="btn add-field"
                          >
                            + Add a field
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => onAddWidgetClick(i, j)}
                          className="btn add-field"
                        >
                          + Add a field
                        </button>
                      )}
                    </div>
                  );
                } else {
                  return (
                    <div className="col" key={j}>
                      <div className="widget-reorder-icn">
                        {j > 0 && (
                          <i
                            title="Move left"
                            onClick={() => reorderCols(i, j, true)}
                            className="fas fa-arrow-left "
                          ></i>
                        )}
                        {j < item.rowItems.length - 1 && (
                          <i
                            title="Move right"
                            onClick={() => reorderCols(i, j, false)}
                            className="fas fa-arrow-right "
                          ></i>
                        )}
                      </div>

                      <br />
                      {col.length > 0 &&
                        col.map((d, k) => {
                          let widget = d;

                          return (
                            <div key={k}>
                              {widget.itemId ? (
                                <div className="widget-basket">
                                  <span className="title">{widget.title}</span>
                                  <span className="actions">
                                    {k > 0 && (
                                      <i
                                        title="Move up"
                                        onClick={() =>
                                          reorderWidget(i, j, k, true)
                                        }
                                        className="fas fa-arrow-up "
                                      ></i>
                                    )}
                                    {k < col.length - 1 && (
                                      <i
                                        title="Move down"
                                        onClick={() =>
                                          reorderWidget(i, j, k, false)
                                        }
                                        className="fas fa-arrow-down "
                                      ></i>
                                    )}
                                    {isCustomMenu && (
                                      <i
                                        onClick={() => editWidget(i, j, k)}
                                        className="fas fa-edit"
                                      ></i>
                                    )}
                                    {widget.isActive ? (
                                      <i
                                        title="Active"
                                        onClick={() =>
                                          setWidgetVisibility([i, j, k])
                                        }
                                        className="fas fa-eye"
                                      ></i>
                                    ) : (
                                      <i
                                        onClick={() =>
                                          setWidgetVisibility([i, j, k])
                                        }
                                        className="fas fa-eye-slash"
                                        title="Inactive"
                                      ></i>
                                    )}
                                    {
                                      <i
                                        className="fas fa-trash-alt"
                                        onClick={() => deleteWidget([i, j, k])}
                                      >
                                        {" "}
                                      </i>
                                    }
                                  </span>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          );
                        })}

                      <button
                        style={{ height: "20px" }}
                        onClick={() => onAddWidgetClick(i, j)}
                        className="btn add-field"
                      >
                        + Add a field
                      </button>
                    </div>
                  );
                }
              })}
            </div>
          ))}
        {isCustomMenu && (
          <div className="add-layout show-component">
            <button className="btn" onClick={() => setShowLayout(true)}>
              + Click here to add a layout.
            </button>
            {showLayout && <SelectLayout onLayoutSelect={onLayoutSelect} />}
          </div>
        )}

        {showAddWidget && (
          <AddWidget
            editWidgetInfo={editWidgetInfo}
            onWidgetSelect={onWidgetSelected}
            closeWidget={() => setShowAddWidget(false)}
            template={template}
            tierId={tier}
            subTiers={subTiers}
            isBaseLayout={isBaseLayout}
          />
        )}
      </div>
    </ScrollView>
  );
};
